import { render, staticRenderFns } from "./CommonPagination.vue?vue&type=template&id=7ccb8c86&scoped=true&"
import script from "./CommonPagination.vue?vue&type=script&lang=js&"
export * from "./CommonPagination.vue?vue&type=script&lang=js&"
import style0 from "./CommonPagination.vue?vue&type=style&index=0&id=7ccb8c86&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7ccb8c86",
  null
  
)

export default component.exports